import { render, staticRenderFns } from "./IdentityCreateEdit.vue?vue&type=template&id=36aaac4e&"
import script from "./IdentityCreateEdit.vue?vue&type=script&lang=ts&"
export * from "./IdentityCreateEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports